import { Unit } from 'models/Unit';

export class FuelType {
    id: number;
    name: string;
    unit?: Unit | null;
    archivedDate?: Date;

    constructor(
        id: number,
        name: string,
        unit?: Unit | null,
        archivedDate?: Date
    ) {
        this.id = id;
        this.name = name;
        this.unit = unit;
        this.archivedDate = archivedDate;
    }

    static empty(): FuelType {
        return { id: 0, name: '', unit: Unit.empty()};
    }

}